var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "page-content", attrs: { id: "actionpoints" } },
    [
      _c(
        "Titlebar",
        {
          staticClass: "with-tree-dropdown",
          attrs: { incrustation: "beepiz-marker" },
        },
        [
          _c("h1", [_vm._v(_vm._s(_vm.$t("ap.titles.manager")))]),
          _vm._v(" "),
          _c("TreeDropDown", {
            staticStyle: { "margin-left": "1.5rem" },
            attrs: {
              treeData: _vm.treeDataPlans,
              treeOptions: _vm.optionsDropDown,
              selected: _vm.selectedPlan,
              icons: _vm.iconsPlans,
            },
            on: { treeNodeClick: _vm.handlePlanNode },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "row",
          staticStyle: { height: "calc(100vh - 78px - 100px)" },
        },
        [
          _c("LoadingMini", { ref: "loading" }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col-4 full-height" },
            [
              _c(
                "UiCard",
                {
                  staticClass: "full-height",
                  staticStyle: { overflow: "auto" },
                },
                [
                  _c("tree", {
                    ref: "treeAP",
                    attrs: {
                      treeData: _vm.treeData,
                      options: _vm.options,
                      icons: _vm.iconsAP,
                    },
                    on: {
                      treeNodeClick: _vm.handleNode,
                      treeNodeRightClick: _vm.handleRightClick,
                      move: _vm.handleMoveTreeNode,
                      endDrag: _vm.handleEndTreeDrag,
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col-8 full-height" },
            [
              _c(
                "UiCard",
                {
                  staticClass: "full-height relative",
                  staticStyle: { padding: "0 !important", overflow: "hidden" },
                },
                [
                  _c("div", {
                    staticClass: "plans-logo",
                    domProps: { innerHTML: _vm._s(_vm.logo) },
                  }),
                  _vm._v(" "),
                  _c("OutdoorMap", {
                    ref: "map",
                    class: [
                      { show: _vm.mapMode == 1 },
                      { drawing: _vm.isDrawing },
                    ],
                    attrs: {
                      data: _vm.apData,
                      center: _vm.center,
                      zoom: _vm.zoom,
                      readOnlyMode: _vm.outdoorReadOnlyMode,
                    },
                    on: {
                      loaded: _vm.onMapLoaded,
                      markerMoved: _vm.handleMarkerMoved,
                    },
                  }),
                  _vm._v(" "),
                  _c("IndoorMap", {
                    ref: "indoorMap",
                    class: { show: _vm.mapMode == 2 },
                    attrs: { plan: _vm.plan, data: _vm.apData },
                    on: { markerMoved: _vm.handleMarkerMoved },
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "helper", class: { show: _vm.isDrawing } },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.$t("ap.drawingHelper")) +
                          "\n                "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "Toolbar",
        [
          _c(
            "Btn",
            {
              directives: [
                {
                  name: "can",
                  rawName: "v-can",
                  value: "beepiz-add-actionpoints",
                  expression: "'beepiz-add-actionpoints'",
                },
                {
                  name: "on-clickaway",
                  rawName: "v-on-clickaway",
                  value: _vm.closeAddActions,
                  expression: "closeAddActions",
                },
              ],
              class: [{ "no-hover": _vm.showActions.add }, "default"],
              attrs: { disabled: !_vm.addIsActive },
              nativeOn: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.toggleActions("add")
                },
              },
            },
            [
              _c(
                "div",
                {
                  staticClass: "button-actions",
                  class: { show: _vm.showActions.add },
                },
                [
                  _c("ul", [
                    _c(
                      "li",
                      {
                        class: { disabled: !_vm.rulesForAdd.ap },
                        on: {
                          click: function ($event) {
                            $event.stopPropagation()
                            return _vm.showModalAddAP($event)
                          },
                        },
                      },
                      [
                        _c("i", { staticClass: "fa beepiz-marker fa-fw" }),
                        _vm._v(
                          " " +
                            _vm._s(_vm.$t("ap.btns.addActions.ap")) +
                            "\n                    "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "li",
                      {
                        class: { disabled: !_vm.rulesForAdd.group },
                        on: {
                          click: function ($event) {
                            $event.stopPropagation()
                            return _vm.showModalAddGroup($event)
                          },
                        },
                      },
                      [
                        _c("i", { staticClass: "beepiz-folder fa-fw" }),
                        _vm._v(
                          " " +
                            _vm._s(_vm.$t("ap.btns.addActions.group")) +
                            "\n                    "
                        ),
                      ]
                    ),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c("i", { staticClass: "fa fa-caret-up" }),
              _vm._v(" "),
              _c("span", [_vm._v(_vm._s(_vm.$t("global.add")))]),
            ]
          ),
          _vm._v(" "),
          _c(
            "Btn",
            {
              directives: [
                {
                  name: "can",
                  rawName: "v-can",
                  value:
                    "beepiz-edit-actionpoints || beepiz-delete-actionpoints",
                  expression:
                    "'beepiz-edit-actionpoints || beepiz-delete-actionpoints'",
                },
              ],
              class: [{ "no-hover": _vm.showActions.options }, "default"],
              nativeOn: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.toggleActions("options")
                },
              },
            },
            [
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "on-clickaway",
                      rawName: "v-on-clickaway",
                      value: _vm.closeOptionsActions,
                      expression: "closeOptionsActions",
                    },
                  ],
                  staticClass: "button-actions",
                  class: { show: _vm.showActions.options },
                },
                [
                  _c("ul", [
                    _c(
                      "li",
                      {
                        directives: [
                          {
                            name: "can",
                            rawName: "v-can",
                            value: "beepiz-delete-actionpoints",
                            expression: "'beepiz-delete-actionpoints'",
                          },
                        ],
                        class: { disabled: !_vm.selectedNode },
                        on: {
                          click: function ($event) {
                            $event.stopPropagation()
                            return _vm.handleDeleteAction($event)
                          },
                        },
                      },
                      [
                        _c("i", { staticClass: "fa fa-trash fa-fw" }),
                        _vm._v(
                          " " +
                            _vm._s(_vm.$t("ap.btns.delete")) +
                            "\n                    "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "li",
                      {
                        directives: [
                          {
                            name: "can",
                            rawName: "v-can",
                            value: "beepiz-edit-actionpoints",
                            expression: "'beepiz-edit-actionpoints'",
                          },
                        ],
                        class: { disabled: !_vm.selectedNode },
                        on: {
                          click: function ($event) {
                            $event.stopPropagation()
                            return _vm.showModalEditAP($event)
                          },
                        },
                      },
                      [
                        _c("i", { staticClass: "fa fa-pencil fa-fw" }),
                        _vm._v(
                          " " +
                            _vm._s(_vm.$t("global.edit")) +
                            "\n                    "
                        ),
                      ]
                    ),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c("i", { staticClass: "fa fa-caret-up" }),
              _vm._v(" "),
              _c("span", [_vm._v(_vm._s(_vm.$t("global.options")))]),
            ]
          ),
          _vm._v(" "),
          _c(
            "Btn",
            {
              directives: [
                {
                  name: "can",
                  rawName: "v-can",
                  value: "beepiz-browse-plans",
                  expression: "'beepiz-browse-plans'",
                },
              ],
              class: "primary pull-right",
            },
            [
              _c(
                "router-link",
                { attrs: { to: _vm.routePlansManager, tag: "span" } },
                [
                  _c("i", { staticClass: "fa fa-map" }),
                  _c("span", [_vm._v(_vm._s(_vm.$t("ap.btns.plansManager")))]),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "Modal",
        {
          ref: "modalAddAP",
          staticClass: "ActionPointsModal",
          attrs: { width: _vm.modalApWidth, height: "100%" },
        },
        [
          _c("span", {
            attrs: { slot: "header" },
            domProps: { innerHTML: _vm._s(_vm.$t("ap.titles.add.ap")) },
            slot: "header",
          }),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "full-height scroll",
              attrs: { slot: "content" },
              slot: "content",
            },
            [
              _c("Library", {
                ref: "library",
                attrs: { chrome: false, planId: _vm.selectedPlanId },
                on: {
                  selectAP: _vm.handleSelectAp,
                  cancelAP: _vm.handleCancelAp,
                },
              }),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c("Modal", { ref: "modalAddAPGroup" }, [
        _c("span", {
          attrs: { slot: "header" },
          domProps: { innerHTML: _vm._s(_vm.$t("ap.titles.add.group")) },
          slot: "header",
        }),
        _vm._v(" "),
        _c(
          "div",
          { attrs: { slot: "content" }, slot: "content" },
          [
            _c("ModalAPGroup", {
              ref: "modalAddAPGroupForm",
              on: {
                addGroup: _vm.handleAddGroup,
                editGroup: _vm.handleEditGroup,
                close: _vm.handleCloseGroup,
              },
            }),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }